/**
 * Redux Store Configuration
 * 
 * Configures the Redux store with:
 * - Auth slice
 * - RTK Query API
 * - Redux DevTools (development only)
 */

import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../auth/store/authSlice';
import { baseApi } from '../api/baseApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
  devTools: import.meta.env.DEV,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
